<template>
    <div class="promo">
        <vue-easy-lightbox
            :visible="image_show_fsize"
            :imgs="image_show_path"
            @hide="close_image"
            >
        </vue-easy-lightbox>
        <v-layout row wrap>
            <v-flex xs12 md12 lg12>
                <v-card>
                    <v-toolbar flat class="accent">
                        <span class="white--text headline font-weight-medium hidden-sm-and-down">
                            Действующие акции
                        </span>
                        <span class="white--text body-2 font-weight-medium hidden-md-and-up">
                            Действующие акции
                        </span>
                        <v-spacer></v-spacer>
                        <div class="d-inline-flex">
                            <v-icon large color="white">view_array</v-icon>
                            <v-switch v-model="grid_view"
                                      color="white" class="px-2 mt-3"
                            ></v-switch>
                            <v-icon large color="white">view_module</v-icon>
                        </div>
                    </v-toolbar>
                    <v-card-text>
                        <v-container grid-list-md fluid>
                            <v-layout row wrap v-if="grid_view">
                                <v-flex v-for="(item,i) in promo.files" :key="i" xs12 sm6 md4 d-flex>
                                   <v-card>
                                        <v-card-text>
                                            <v-img style="cursor: pointer;"
                                                    :src="item.path+item.name"
                                                    @click="view_image(item.path+item.name)"
                                                    class="white" contain
                                            ></v-img>
                                        </v-card-text>
                                    </v-card>
                               </v-flex>
                            </v-layout>
                            <v-layout v-else row justify-center>
                                <v-flex xs12 md10 lg8>
                                    <v-card>
                                        <v-card-text>
                                            <v-carousel :interval="10000">
                                                <v-carousel-item v-for="(item,i) in promo.files" :key="i">
                                                    <v-img style="cursor: pointer; height: auto; height: -webkit-fill-available;"
                                                            :src="item.path+item.name"
                                                            @click="view_image(item.path+item.name)"
                                                            class="secondary" contain
                                                    ></v-img>
                                                </v-carousel-item>
                                            </v-carousel>
                                        </v-card-text>
                                    </v-card>
                                    </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}
            <v-btn flat @click="snack = false" :ripple="false">Закрыть</v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import $ from 'jquery';
    export default {
        name: "Promo",
        data(){
            return {
                grid_view: true,
                // Lightbox
                image_show_fsize: false,
                image_show_path: '',
                // Snack
                snack: false,
                snackColor: '',
                snackText: '',
                // Folder files
                promo: {
                    files: [],
                },
            }
        },
        mounted() {
            this.load_json();
        },
        methods: {
            // Request to list files in folders
            load_json() {
                $.ajax({
                    url: '/content/media/promo.json',
                    type: 'GET',
                    data: {},
                    success: (response) => {
                        if (typeof response === 'object')
                            this.promo.files = response;
                    },
                    error: () => {
                        this.promo.files = [];
                   },
                });
            },
            // Lightbox
            view_image(image_path){
                this.image_show_fsize = true;
                this.image_show_path = image_path;
            },
            close_image(){
                this.image_show_fsize = false;
                this.image_show_path = '';
            },
            // Form MISC
            show_snack(snack_color, snack_text) {
                this.snack = true;
                this.snackColor = snack_color;
                this.snackText = snack_text;
            },
        },
    }
</script>

<style scoped>

</style>